import { IS_CLIENT, IS_PRODUCTION } from '@repo/common-utils';

import { NaverPixelEventParams, NaverPixelInitializeProps } from '../types';

export class NaverPixelService {
  private readonly pixelId: string;
  private preservedEvents: NaverPixelEventParams[] = [];
  private retryCount: number = 0;
  private retryTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor({ naverPixelId }: NaverPixelInitializeProps) {
    this.pixelId = naverPixelId ?? '';
    this.init();
  }

  private init() {
    if (!IS_CLIENT) return;
    this.sendInitEvent();
  }

  sendEvent(params: NaverPixelEventParams) {
    if (typeof window.wcs !== 'object' || !window.wcs?.trans) {
      this.preservedEvents.push(params);
      return;
    }

    setTimeout(() => {
      window.wcs.trans(params);
      this.printLog(params);
    }, 200);
  }

  private sendInitEvent() {
    if (typeof window.wcs === 'object') {
      if (!window.wcs_add) {
        window.wcs_add = {};
      }
      window.wcs_add['wa'] = this.pixelId;
      window.wcs.inflow(process.env.NEXT_PUBLIC_SERVICE_DOMAIN ?? window.location.hostname);
      this.printLog({ type: 'Init', pixelId: this.pixelId });
      this.preservedEvents.forEach((event) => this.sendEvent(event));
      this.preservedEvents = [];
      return;
    } else if (this.retryCount < 10) {
      if (this.retryTimeout) clearTimeout(this.retryTimeout);
      this.retryTimeout = setTimeout(() => {
        this.retryCount++;
        this.sendInitEvent();
      }, 500);
    }
  }

  private printLog(params: Record<string, unknown>) {
    if (!IS_PRODUCTION && process.env.NEXT_PUBLIC_TRACKING_DEBUG_MODE === 'true') {
      console.info('%c[NaverPixel]', 'font-weight: bold;', params.type, [params]);
    }
  }
}
